<script setup lang="ts">
import { ref } from 'vue';
import Typography from '../../../../_01_atoms/components/Typography.vue';
import { trans } from '../../../../_00_elements/translation';
import UpdateStripePaymentMethodButton from '../../components/Stripe/UpdateStripePaymentMethodButton.vue';

const company = ref<string>(window.COMPANY_NAME);
</script>

<template>
  <div class="payment-method__empty-state empty-state-card card">
    <div class="card-icon">
      <div class="bank-account-icon" />
    </div>

    <Typography variant="content-heading-1">
      {{ trans('gestion.pay.payment_method.empty_state.title') }}
    </Typography>

    <UpdateStripePaymentMethodButton />
  </div>
</template>
